function UpcomingEvents() {
  return <h2>Welcome to Upcoming Events</h2>;
}
export default UpcomingEvents;